import {
  Component,
  EventEmitter,
  Input,
  Output,
  AfterContentChecked,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-switch-checkbox',
  templateUrl: './switch-checkbox.component.html',
  styleUrls: ['./switch-checkbox.component.scss'],
})
export class SwitchCheckboxComponent implements AfterContentChecked {
  @Input() stylingClass = '';
  @Input() innerId: string;
  @Input() checked = false;
  @Input() disabled: boolean;
  @Input() hoverable = true;
  @Input() bsClass = 'success';
  @Input() hideCheckbox = false;
  @Input() tooltip = '';
  @Input() bsSize: 'lg' | 'sm' | 'md' = 'md';
  @Input() useConfrimModal = false;
  @Input() modalHeaderText = '';
  @Input() modalBodyText = '';
  @Input() modalButtonText = 'Confirm';
  @Output() change = new EventEmitter<boolean>();

  //value is used to help test automation perform checks to this element
  value: string;

  constructor(private modalService: NgbModal) {}

  ngAfterContentChecked() {
    this.value = `checked=${this.checked ? 'true' : 'false'}`;
  }
  onChange(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    if (!this.disabled) {
      if (this.useConfrimModal && !this.checked) {
        this.setUpModal();
      } else {
        this.checked = !this.checked;
        this.value = `checked=${this.checked ? 'true' : 'false'}`;
        this.change.emit(this.checked);
      }
    }
  }

  setUpModal() {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      backdrop: 'static',
      keyboard: false,
    });

    const { componentInstance } = modalRef;

    componentInstance.headerText = this.modalHeaderText;
    componentInstance.bodyText = this.modalBodyText;
    componentInstance.confirmButtonText = this.modalButtonText;
    componentInstance.confirmationResult.subscribe((hasVerified: boolean) => {
      if (hasVerified) {
        this.checked = !this.checked;
        this.value = `checked=${this.checked ? 'true' : 'false'}`;
        this.change.emit(this.checked);
        modalRef.close();
      }
    });

    componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }
}
